import * as React from "react";

import styled from "@emotion/styled";
import { FeatureSmall, FeatureSmallProps } from "./feature-small";
import { breakpoints } from "../styles/breakpoints";

const StyledFeaturesSmall = styled.div`
	display: flex;
  flex-wrap: wrap;
	justify-content: space-around;

  @media(max-width: ${breakpoints.sm}) {
   flex-direction: column;
   align-items: center;
  }

  & > * { 
    flex: 0 0 24%;
  }
`;

export const FeaturesSmall = ({
  features,
}: {
  features: FeatureSmallProps[];
}) => (
  <StyledFeaturesSmall>
    {features.map((f) => (
      <FeatureSmall key={f.title} {...f} />
    ))}
  </StyledFeaturesSmall>
);
